import React, { useState, useEffect } from "react";
import { Filter } from "react-feather";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { useParams, useNavigate } from "react-router-dom";
import { baseurl, imageUrl } from "../Baseurl";
import axios from "axios";
import noproduct from "../component/img/product_not_found.jpeg";

const Education = () => {
  const [educationProfiles, setEducationProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const [categories, setCategories] = useState([]);
  const [categoryLevels, setCategoryLevels] = useState([]); // [{level: 0, categories: [...]}, ...]
  const [checkedCategories, setCheckedCategories] = useState([]); // selected category ids

  const { slug } = useParams();
  const navigate = useNavigate();

  // Fetch all categories
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${baseurl}getAllEducationCategories`);
      const data = res.data.data || [];
      setCategories(data);

      // Build top-level categories (parent_id null or 0)
      const level0 = data.filter((c) => !c.parent_id);
      setCategoryLevels([{ level: 0, categories: level0 }]);

      // If slug is provided, set checked categories
      if (slug) {
        const currentCat = data.find((c) => c.slug === slug);
        if (currentCat) {
          const hierarchy = [];
          let cat = currentCat;
          while (cat) {
            hierarchy.unshift(cat.id);
            cat = data.find((c) => c.id === cat.parent_id);
          }
          setCheckedCategories(hierarchy);
          loadSubLevels(hierarchy, data);
        }
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // Fetch all education profiles
  const fetchEducationProfiles = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseurl}getAllEducationProfiles`);
      const profiles = res.data || [];
      setEducationProfiles(profiles);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching education profiles:", err);
      setLoading(false);
    }
  };

  // Build sub-levels based on selected hierarchy
  const loadSubLevels = (selectedIds, allCategories) => {
    const levels = [];
    let parentId = null;

    selectedIds.forEach((id, idx) => {
      const options = allCategories.filter((c) => c.parent_id === parentId);
      levels.push({ level: idx, categories: options });
      parentId = id;
    });

    // Add next level options if exist
    const nextLevel = allCategories.filter((c) => c.parent_id === parentId);
    if (nextLevel.length > 0) {
      levels.push({ level: levels.length, categories: nextLevel });
    }

    setCategoryLevels(levels);
  };

// Handle checkbox click
const handleCheckboxChange = (levelIndex, categoryId) => {
  const updated = [...checkedCategories];
  updated[levelIndex] = categoryId;
  updated.length = levelIndex + 1; // remove deeper selections
  setCheckedCategories(updated);

  loadSubLevels(updated, categories);

  // REMOVE navigation, we just filter in-place
  // const cat = categories.find((c) => c.id === categoryId);
  // if (cat) navigate(`/education/${cat.slug}`);
};

  // Filter profiles whenever checked categories change
 // Filter profiles whenever checked categories change
useEffect(() => {
  if (checkedCategories.length === 0) {
    setFilteredProfiles(educationProfiles);
  } else {
    const filtered = educationProfiles.filter((profile) => {
      let ids = profile.category_id;

      // Ensure ids is always an array
      if (!ids) ids = [];
      else if (!Array.isArray(ids)) ids = [ids];

      return ids.some((id) => checkedCategories.includes(id));
    });
    setFilteredProfiles(filtered);
  }
}, [checkedCategories, educationProfiles]);



  useEffect(() => {
    fetchCategories();
    fetchEducationProfiles();
  }, [slug]);

  // Extract YouTube ID
  const extractYouTubeID = (url) => {
    if (!url) return null;
    const regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-4">
          {/* Filters */}
          <div className="col-md-2 hide-on-mobile">
            <h4 className="product-desc-title">
              Filters <Filter size={20} />
            </h4>
            <div className="filter-sidebar">
              {categoryLevels.map((level, idx) => {
                const heading =
                  idx === 0
                    ? "Education Categories"
                    : categories.find((c) => c.id === checkedCategories[idx - 1])
                        ?.education_title || `Level ${idx + 1}`;
                return (
                  <div key={idx} className="mb-2">
                    <div className="d-block mb-1 text-start">{heading}</div>
                    {level.categories.map((cat) => (
                      <div key={cat.id} className="form-check text-start">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`cat-${cat.id}`}
                          checked={checkedCategories[idx] === cat.id}
                          onChange={() => handleCheckboxChange(idx, cat.id)}
                        />
                        <label
                          htmlFor={`cat-${cat.id}`}
                          className="form-check-label text-capitalize"
                          style={{ cursor: "pointer" }}
                        >
                          {cat.education_title}
                        </label>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Education Profiles */}
          <div className="col-md-10">
            <h4 className="product-desc-title">Education Profiles</h4>
            {loading ? (
              <p>Loading...</p>
            ) : filteredProfiles.length > 0 ? (
              <div className="row g-2">
                {filteredProfiles.map((profile) => (
                  <div className="col-md-3 col-6" key={profile.id}>
                    <div className="product-card">
                      {profile.youtube_link ? (
                        <div
                          className="video-preview"
                          style={{
                            position: "relative",
                            paddingBottom: "56.25%",
                            height: 0,
                            overflow: "hidden",
                          }}
                        >
                          <iframe
                            title={profile.name}
                            src={`https://www.youtube.com/embed/${extractYouTubeID(
                              profile.youtube_link
                            )}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </div>
                      ) : profile.pdf_filename ? (
                        <a
                          href={`${baseurl}educationpdfs/${profile.pdf_filename}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "block",
                            textAlign: "center",
                            padding: "1rem",
                          }}
                        >
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                            alt="PDF preview"
                            style={{ width: "100px", height: "auto" }}
                          />
                          <div>View PDF</div>
                        </a>
                      ) : (
                        <img src={noproduct} alt={profile.name} />
                      )}

                      <div className="text-start">
                        <h3 className="text-start mb-0">{profile.name}</h3>
                      </div>

                      {profile.youtube_link && (
                        <a
                          href={profile.youtube_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm 1"
                        >
                          Watch Video
                        </a>
                      )}
                      {!profile.youtube_link && profile.pdf_filename && (
                        <a
                          href={`${imageUrl}education/${profile.pdf_filename}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-secondary btn-sm"
                        >
                          View PDF
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center">
                <img
                  src={noproduct}
                  className="img-fluid noproductimg"
                  alt="No Education Profiles Found"
                />
              </p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Education;
